// extracted by mini-css-extract-plugin
export default {"main":"SelectEnterPage_main__N32i+"};